import { render, staticRenderFns } from "./Challenges.vue?vue&type=template&id=4ff55bed&scoped=true&"
import script from "./Challenges.vue?vue&type=script&lang=js&"
export * from "./Challenges.vue?vue&type=script&lang=js&"
import style0 from "./Challenges.vue?vue&type=style&index=0&id=4ff55bed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff55bed",
  null
  
)

export default component.exports